import React from 'react';
import { m as motion } from 'framer-motion';
import { Container } from './ui/Container';
import { SectionTag } from './ui/SectionTag';
import { CTAButton } from './ui/CTAButton';
import { CheckItem } from './ui/CheckItem';
import { GuaranteeLine } from './ui/GuaranteeLine';
import { ValueBreakdown } from './ui/ValueBreakdown';
import { BASE_CHECKOUT_URL } from '../data/checkoutLinks';
const easeOut: [number, number, number, number] = [0.23, 1, 0.32, 1];
const includes = ['5 tomos especializados (250+ páginas)', 'Fichas de Pista (25 fichas)', 'Radar del Alumno', 'Semáforo de Correcciones Rápidas', 'Planificador 30 Días', 'Vuelta a Pista'];
export function PricingCards() {
  return <section id="oferta" className="bg-mp-black py-20 md:py-28 scroll-mt-20" data-id="element-152" data-mp="2p4yu7r3e26xt">
      <Container data-id="element-153" data-mp="2u41tsw0lnkye">
        <div className="mx-auto max-w-[700px] text-center" data-id="element-154" data-mp="2u4l6nybe7j5k">
          <SectionTag tone="lime" data-id="element-155" data-mp="2z2wde06e5djk">Oferta de lanzamiento</SectionTag>
          <h2 className="mt-5 font-heading text-3xl uppercase leading-tight text-mp-white sm:text-4xl md:text-5xl" data-id="element-156" data-mp="2z34rfve92owc">
            ¿Cuánto vale para ti recuperar tu tiempo?
          </h2>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-60px'
      }} transition={{
        duration: 0.4,
        ease: easeOut
      }} className="mx-auto mt-12 max-w-[520px] rounded-2xl border-2 border-mp-lime bg-mp-card p-7 shadow-glow-lime md:p-9" data-id="element-157" data-mp="3ogi7fl237m6h">
          <p className="font-heading text-xl uppercase tracking-wide text-mp-white" data-id="element-158" data-mp="b2evqvm17a3t">Maestro en Pista</p>
          <p className="mt-1 text-sm text-mp-gray" data-id="element-159" data-mp="6bot3q4zplct">El sistema completo para dejar de improvisar tus clases</p>

          <ul className="mt-6 space-y-2.5" data-id="element-160" data-mp="29jyop6pwkp4">
            {includes.map(item => <CheckItem key={item} data-id="element-161" data-mp="yt15crbop2fx">{item}</CheckItem>)}
          </ul>

          <div className="mt-8" data-id="element-162" data-mp="u216vhmx2cbb">
            <ValueBreakdown lines={[{
            label: 'Colección 5 Tomos (250+ páginas)',
            value: '89€'
          }, {
            label: 'Los 5 Bonos de Implementación',
            value: '65€'
          }]} totalLabel="Valor total" totalValue="154€" finalPrice="16,99 €" discountPercent="89%" priceTone="lime" data-id="element-163" data-mp="u0q2bflnd0j5" />
          </div>

          <CTAButton href={BASE_CHECKOUT_URL} className="w-full" showArrow data-id="element-164" data-mp="2jhbw3l59h544">
            Quiero Maestro en Pista
          </CTAButton>
          <GuaranteeLine className="mt-4" data-id="element-165" data-mp="2ai8b2bmjafmz" />
        </motion.div>

        <p className="mx-auto mt-10 max-w-[600px] text-center text-sm text-mp-gray" data-id="element-166" data-mp="2ajt3nvpafoi7">
          ⏳ Precio de lanzamiento — sube próximamente. Asegura el tuyo hoy.
        </p>
      </Container>
    </section>;
}